import "./LevelLegend.scss";

const LevelLegend = (props: any) => {
  const { payload } = props;
  return (
    <div className="bar-legend" style={{ width: "100%" }}>
      {payload.map((entry: any, index: number) => (
        <div key={`level-legend-${index}`} className="bar-legend-singleValue">
          <div
            className="color-box"
            style={{ backgroundColor: `${entry.color}` }}
          />
          <p>{entry.value}</p>
        </div>
      ))}
    </div>
  );
};

export default LevelLegend;
